import React from 'react';
import clsx from 'clsx';

import styles from '../styles.module.scss';
import fakeDetectionStyles from './FakeDetection.module.scss';
import {ArrowLong} from '../../../assets';

export const FakeDetectionCard = () => {
  return (
    <div className={fakeDetectionStyles.card}>
      <div className={styles.top}>
        <div className={clsx(styles.label, styles.moderation)}>
          <div className={clsx(styles.labelInner, styles.moderation)}>moderation</div>
        </div>
        <div className={styles.buttonForward}>
          <ArrowLong />
        </div>
      </div>

      <h4 className={styles.title}>Fake Detection</h4>
      <p className={styles.subTitle}>
        Also known as impersonator detection. The algorithm, created in October 2021, has been
        improved and can now detect fake accounts accurately.
      </p>
    </div>
  );
};
